export const hacktivitiesBasePath = `/hacktivities/search?&page=1&kind=`;
